export default __webpack_public_path__ + "4e3419b1c99cb17ed9cec7a59c47e227.jpg";